import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  getAmsApi(context, obj) {
    return axios
      .post(`${appConfig.apiEndPoint}${endpoint.dashboard.amschart}`, obj, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getProductOrder(context, obj) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.dashboard.productOrderCount}`,
        obj,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getTop10CustomersApi(context, obj) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.dashboard.getTop10CustomersApi}`,
        obj,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getReissueApi(context, obj) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.dashboard.getReissueApi}`,
        obj,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getManualRequestApi(context, obj) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.dashboard.getManualRequestApi}`,
        obj,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
